export function applyMatrixToGeometry(object) {
  object.updateMatrix();
  object.geometry.applyMatrix4(object.matrix);
  object.applyMatrix4(object.matrix.clone().invert());
  return object;
}

export function applyMatrixToGeometryRecursive(object) {
  object.updateWorldMatrix(true, true);
  if (object.geometry) {
    try {
      object.geometry.applyMatrix4(object.matrixWorld);
    } catch (e) {
      console.error(e);
    }
  }
  for (const child of object.children) {
    applyMatrixToGeometryRecursive(child);
  }
  try {
    object.applyMatrix4(object.matrix.clone().invert());
    object.updateWorldMatrix(true, true);
  } catch (e) {
    console.error(e);
  }
  return object;
}
